// Ported from bpm-frontend's src/utils/linearBuyingSharedUtils.ts (DEMO_GROUPINGS/
// PRETTY_DEMO_NAMES/OVERLAPPING_DEMO_LOOKUP) -- kept verbatim since the demo value strings
// (e.g. 'm18_34') are the actual persisted/backend values, not display labels.
export const DemoGroup = {
  META: 'Meta',
  MEN: 'Men',
  WOMEN: 'Women'
} as const;
export type DemoGroupType = (typeof DemoGroup)[keyof typeof DemoGroup];

export const DEMO_GROUPINGS: Record<DemoGroupType, Record<string, string>> = {
  [DemoGroup.META]: {
    HH: 'hh',
    'M18+': 'm18plus',
    'W18+': 'w18plus',
    'A18+': 'a18plus',
    'A18-34': 'a18_34',
    'A18-49': 'a18_49',
    'A25-54': 'a25_54',
    'A35-54': 'a35_54',
    'A55+': 'a55plus'
  },
  [DemoGroup.MEN]: {
    '18 - 20': 'm18_20',
    '18 - 34': 'm18_34',
    '18 - 49': 'm18_49',
    '21 - 24': 'm21_24',
    '25 - 29': 'm25_29',
    '25 - 54': 'm25_54',
    '30 - 34': 'm30_34',
    '35 - 39': 'm35_39',
    '35 - 54': 'm35_54',
    '40 - 44': 'm40_44',
    '45 - 49': 'm45_49',
    '50 - 54': 'm50_54',
    '55 - 64': 'm55_64',
    '55+': 'm55plus',
    '65+': 'm65plus'
  },
  [DemoGroup.WOMEN]: {
    '18 - 20': 'w18_20',
    '18 - 34': 'w18_34',
    '18 - 49': 'w18_49',
    '21 - 24': 'w21_24',
    '25 - 29': 'w25_29',
    '25 - 54': 'w25_54',
    '30 - 34': 'w30_34',
    '35 - 39': 'w35_39',
    '35 - 54': 'w35_54',
    '40 - 44': 'w40_44',
    '45 - 49': 'w45_49',
    '50 - 54': 'w50_54',
    '55 - 64': 'w55_64',
    '55+': 'w55plus',
    '65+': 'w65plus'
  }
};

const buildPrettyDemoNames = (): Record<string, string> => {
  const names: Record<string, string> = {
    hh: 'HH',
    m18plus: 'M18+',
    w18plus: 'W18+',
    a18plus: 'A18+',
    a18_34: 'A18-34',
    a18_49: 'A18-49',
    a25_54: 'A25-54',
    a35_54: 'A35-54',
    a55plus: 'A55+'
  };
  for (const [key, value] of Object.entries(DEMO_GROUPINGS[DemoGroup.MEN])) {
    names[value] = `M${key}`.replace(/ /g, '');
  }
  for (const [key, value] of Object.entries(DEMO_GROUPINGS[DemoGroup.WOMEN])) {
    names[value] = `W${key}`.replace(/ /g, '');
  }
  return names;
};
export const PRETTY_DEMO_NAMES: Record<string, string> = buildPrettyDemoNames();

// Selecting one demo in this list deselects every demo it overlaps with (e.g. picking "M18-34"
// should drop "M18+" and vice versa) -- bpm's original built this as an empty lookup and never
// actually populated it beyond that, so overlap-deselection has never really applied to anything
// beyond the Meta-demo special case in onSelect. Preserved as-is, not expanded, to match behavior.
export const OVERLAPPING_DEMO_LOOKUP: Record<string, string[]> = Object.fromEntries(
  [
    ...Object.values(DEMO_GROUPINGS[DemoGroup.MEN]),
    ...Object.values(DEMO_GROUPINGS[DemoGroup.WOMEN])
  ].map(value => [value, []])
);
